import React, { Component } from 'react';
import DatosAutorizacionesRechazadas from './DatosAutorizacionesRechazadas';

class RowAutorizacionesRechazadas extends Component {
    constructor(props) {
        super(props);
    }


    render() {

        const { autorizaciones, index, datosAutorizacion } = this.props;


        if (autorizaciones.mostrarDatos) {
            return (<tr>
                <td colSpan={7} className='div-padding-0'><div className="contenedorInfoTarjetaIndividual"> <DatosAutorizacionesRechazadas autorizaciones={autorizaciones} /></div></td>
            </tr>);
        } else {
            return (<tr className={'FontAutorizacionesRechazadas paddingLeftXS paddingTopBottom' + autorizaciones.clase}>
                    <td>
                        {autorizaciones.FechaHora}
                    </td>
                    <td>
                        {autorizaciones.NumeroTarjeta}
                    </td>
                    <td>
                        {autorizaciones.Establecimiento.toUpperCase().slice(0,16).trim()}
                    </td>
                    <td>
                        {autorizaciones.MotivoRechazo.trim()}
                    </td>
                    <td>
                      {autorizaciones.ImporteConversion}
                    </td>
                    <td>
                        {autorizaciones.ImportePesificado}  
                    </td>
                    <td>
                        {autorizaciones.flechaArriba ? <div onClick={() => datosAutorizacion(false,index)} className='menu-desplegableMovimientos seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo accionesIntegrantesIconosAcciones clickable'></div>
                            : <div onClick={() => datosAutorizacion(true,index)} className='menu-desplegableMovimientos seccionRenglonesModelo__renglonModelo__trianguloDown accionesIntegrantesIconosAcciones clickable'></div>}
                    </td>
                </tr>)
        }

    }
}

export default RowAutorizacionesRechazadas;